<template>
    <div>
        <div class="container bg-light mt-5 text-bat">
            <div class="row">
                <div class="col-12 col-md-6">
                    <h5 class="text-title-bat">Cumple tus metas</h5>
                    <p class="fs-6">Aquí puedes ver el avance de tus variables del mes seleccionado.</p>
                </div>
                <div class="col-12 col-sm-12 col-md-12">
                    <div v-if="available_client_months && available_client_months.length">
                        <div class="row d-flex justify-content-start align-items-center">
                            <div class="col-12 col-md-4 d-flex justify-content-start align-items-center">
                                <span class="text-bat fs-6">Filtra por mes:</span>
                                <div class="month-filter ms-2 w-100">
                                    <form>
                                        <select v-model="selected_moth" @change="getCurrentData()">
                                            <option v-for="month in available_client_months" :value="month.month">
                                                {{ getMonthText(month.month) }}
                                            </option>
                                        </select>
                                    </form>
                                </div>
                            </div>
                            <div v-if="unit_guide.length !== 0"
                                class="col-12 col-md-6 mt-3 mt-md-0 d-flex justify-content-center justify-content-md-start">
                                <button class="bg-transparent border-0 " data-bs-toggle="modal"
                                    data-bs-target="#guiaDeUnidadesModal">
                                    <img :src="unit_guide.icon" alt="Guia de unidades">
                                    <span class="fs-6 text-indigo border-bottom text-title-bat">
                                        {{ unit_guide.title }}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal Guia de Unidades -->
            <div class="modal fade" id="guiaDeUnidadesModal" tabindex="-1" aria-labelledby="guiaDeUnidadesModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-sm">
                    <div class="modal-content">
                        <div class="modal-header border-0">
                            <h1 class="modal-title fs-5" id="guiaDeUnidadesModalLabel">{{ unit_guide.title }}</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            </button>
                        </div>
                        <div class="modal-body border-0 d-flex justify-content-center">
                            <img class="img-fluid" :src="unit_guide.image" alt="guia-unidades">
                        </div>
                    </div>
                </div>
            </div>

            <!-- Objetivos Version Desktop -->
            <div v-if="$mq !== 'sm' && show_slick === true" class="carrusel-avances pb-4 my-4">
                <Slick v-if="client_metric_accomplishments && client_metric_accomplishments.length > 0" ref="slick"
                    :options="slickOptions" class="slick-vue">
                    <div v-for="(objetive, index) in client_metric_accomplishments" :key="index"
                        class="row gap-2 d-flex justify-content-center mb-3 position-relative mt-3">
                        <div class="col-11 bg-white px-3 py-4 shadow-sm rounded-4">
                            <div class="col-12 mb-2 position-absolute top-0 end-0 me-4">
                                <span v-if="Number(objetive.variable_points_to_win) > 0 && status_display"
                                    class="py-1 px-2 rounded text-dark text-end float-end d-flex justify-content-center -mt-10"
                                    :class="(Number(objetive.advance_percentage) * 100) >= 100 ? 'box-points-goals' : 'bg-gradient bg-secondary bg-opacity-10'">
                                    <strong class="me-1">
                                        {{ numberFormat(Number(objetive.variable_points_to_win)) }}
                                    </strong>
                                    Puntos
                                </span>
                            </div>
                            <div class="row pt-1 mb-1 d-flex justify-content-between">
                                <div class="col-12">
                                    <h5 class="text-title-bat text-indigo-darkness">
                                        {{ objetive.variable }}
                                    </h5>
                                </div>
                            </div>
                            <p class="mb-1 fs-6">
                                Cumple tu meta:
                                <span v-if="objetive.unit_measure" class="text-title-bat text-indigo">{{
                                    numberFormat(Math.round(Number(objetive.goal))) }} {{ formatUnitMeasure(objetive.unit_measure)
                                    }}</span>
                                <span v-else class="text-title-bat text-indigo">{{ numberFormat(Math.round(Number(objetive.goal))) }}
                                    Unidades</span>
                            </p>
                            <div>
                                <!-- <el-progress
                                    :percentage="(Number(objetive.advance_percentage) * 100) > 100 ? 100 : (Number(objetive.advance_percentage) * 100)"
                                    :color="customColorMethods"
                                    :show-text="false"
                                    class="my-3 mx-0"
                                    :stroke-width="15"
                                ></el-progress> -->
                                <el-progress :text-inside="true"
                                    :percentage="(Number(objetive.advance_percentage) * 100) > 100 ? 100 : Math.floor(Number(objetive.advance_percentage) * 100)"
                                    :color="customColorMethods" :show-text="true" class="my-3 mx-0" :stroke-width="18"
                                    :text-color="'white'">
                                </el-progress>
                            </div>

                            <p class="text-end mb-1 fs-6">
                                Llevas:
                                <span v-if="objetive.unit_measure"
                                    class="text-title-bat bg-opacity-10  p-2 ms-1 rounded"
                                    :class="(Number(objetive.advance_percentage) * 100) >= 100 ? 'bg-success text-success' : 'bg-info text-indigo'">{{
                                    numberFormat(Math.round(Number(objetive.advance_amount))) }} {{
                                    formatUnitMeasure(objetive.unit_measure) }}</span>
                                <span v-else class="text-title-bat bg-opacity-10  p-2 ms-1 rounded"
                                    :class="(Number(objetive.advance_percentage) * 100) >= 100 ? 'bg-success text-success' : 'bg-info text-indigo'">{{
                                    numberFormat(Math.round(Number(objetive.advance_amount))) }} Unidades</span>
                            </p>
                        </div>
                    </div>
                </Slick>
            </div>

            <!-- Objetivos Version Mobile -->
            <div v-if="client_metric_accomplishments && client_metric_accomplishments.length && $mq === 'sm'"
                class="avance-box mt-4">
                <div v-for="(objetive, index) in client_metric_accomplishments" :key="index"
                    class="row gap-2 d-flex justify-content-center my-4 position-relative mt-3">
                    <div class="col-11 bg-white p-3 shadow-sm rounded-4">
                        <div class="col-12 mb-2 position-absolute top-0 end-0 me-4">
                            <span v-if="Number(objetive.variable_points_to_win) > 0 && status_display"
                                class="py-1 px-2 rounded text-dark text-end float-end d-flex justify-content-center -mt-10"
                                :class="(Number(objetive.advance_percentage) * 100) >= 100 ? 'box-points-goals' : 'bg-gradient bg-secondary bg-opacity-10'">
                                <strong class="me-1">
                                    {{ numberFormat(Number(objetive.variable_points_to_win)) }}
                                </strong>
                                Puntos
                            </span>
                        </div>
                        <div class="row pt-2 mb-1 d-flex justify-content-between">
                            <div class="col-12">
                                <h5 class="text-title-bat text-indigo-darkness">
                                    {{ objetive.variable }}
                                </h5>
                            </div>
                        </div>
                        <p class="mb-1 fs-6">
                            Cumple tu meta:
                            <span v-if="objetive.unit_measure" class="text-title-bat text-indigo">{{
                                numberFormat(Math.round(Number(objetive.goal))) }} {{ formatUnitMeasure(objetive.unit_measure)
                                }}</span>
                            <span v-else class="text-title-bat text-indigo">{{ numberFormat(Math.round(Number(objetive.goal))) }}
                                Unidades</span>
                        </p>
                        <div>
                            <el-progress :text-inside="true"
                                :percentage="(Number(objetive.advance_percentage) * 100) > 100 ? 100 : Math.floor(Number(objetive.advance_percentage) * 100)"
                                :color="customColorMethods" :show-text="true" class="my-3 mx-0" :stroke-width="18"
                                :text-color="'white'">
                            </el-progress>
                        </div>
                        <p class="text-end mb-1 fs-6">
                            Llevas:
                            <span v-if="objetive.unit_measure" class="text-title-bat bg-opacity-10  p-2 ms-1 rounded"
                                :class="(Number(objetive.advance_percentage) * 100) >= 100 ? 'bg-success text-success' : 'bg-info text-indigo'">{{
                                numberFormat(Math.round(Number(objetive.advance_amount))) }} {{
                                formatUnitMeasure(objetive.unit_measure) }}</span>
                            <span v-else class="text-title-bat bg-opacity-10  p-2 ms-1 rounded"
                                :class="(Number(objetive.advance_percentage) * 100) >= 100 ? 'bg-success text-success' : 'bg-info text-indigo'">{{
                                numberFormat(Math.round(Number(objetive.advance_amount))) }} Unidades</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Slick from "vue-slick";
import 'slick-carousel/slick/slick.css';
import { EventBus } from './../../app';

export default {
    components: { Slick },
    props: {
        identification: {
            default: null,
        },
        month: {
            default: null,
        },
        year: {
            default: null,
        },
        client_segment: {
            default: 3,
        },
        url_media: {
            default: '',
        },
    },
    data() {
        return {
            loading: 0,
            selected_moth: 0,
            selected_year: 0,
            show_slick: false,
            slickOptions: Object,
            available_client_months: [],
            client_metric_accomplishments: [],
            unit_guide: [],
            status_display: false,
            progressWidth: 40,
        };
    },
    mounted() {
        if (this.month && this.year) {
            this.selected_moth = this.month;
            this.selected_year = this.year;
        }
        this.getUnitGuideData();

        this.slickOptionsProps();
        this.getCurrentData();
        this.getStatusDisplay();
        this.createProgressPoints();

        EventBus.$on('change-select-pdv', function (select_pdv) {
            this.slickOptionsProps();
            this.getCurrentData();
            this.getStatusDisplay();
            this.createProgressPoints();
        }.bind(this));
    },
    methods: {
        getCurrentData() {
            this.loading++;
            this.show_slick = false;
            axios
                .get(
                    `/get-home-from-api-result?identification=${this.identification}&month=${this.selected_moth}&year=${this.selected_year}`
                )
                .then(({ data }) => {
                    this.available_client_months = data.available_client_months;
                    this.client_metric_accomplishments = data.client_metric_accomplishments;
                    this.loading--;
                    this.show_slick = true;
                });
        },
        getStatusDisplay() {
            axios.get(`/status-display/${this.client_segment}`)
            .then(response => {
                this.status_display = response.data.status_display;
            })
            .catch(e => {
                //
            })
        },
        getMonthText(month) {
            switch (month) {
                case 1:
                    return "Enero";
                    break;
                case 2:
                    return "Febrero";
                    break;
                case 3:
                    return "Marzo";
                    break;
                case 4:
                    return "Abril";
                    break;
                case 5:
                    return "Mayo";
                    break;
                case 6:
                    return "Junio";
                    break;
                case 7:
                    return "Julio";
                    break;
                case 8:
                    return "Agosto";
                    break;
                case 9:
                    return "Septiembre";
                    break;
                case 10:
                    return "Octubre";
                    break;
                case 11:
                    return "Noviembre";
                    break;
                case 12:
                    return "Diciembre";
                    break;
                default:
                    break;
            }
        },
        slickOptionsProps() {
            this.slickOptions = {
                dots: true,
                arrows: false,
                infinite: true,
                centerMode: false,
                autoplay: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 1336,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            };
        },
        customColorMethods(percentage) {
            if (percentage >= 100) {
                return 'green';
            } else if (percentage >= 50 && percentage < 100) {
                return 'orange';
            } else {
                return 'red';
            }
        },
        numberFormat(number) {
            const exp = /(\d)(?=(\d{3})+(?!\d))/g
            const rep = '$1.'
            let arr = number.toString().split('.')
            arr[0] = arr[0].replace(exp,rep)
            return arr[1] ? arr.join(','): arr[0]
        },
        formatUnitMeasure(text){
            return text[0].toUpperCase() + text.substring(1).toLowerCase();
        },
        getUnitGuideData() {
            axios
                .get(
                    `get-unit-guide`
                )
                .then(({ data }) => {
                    this.unit_guide = data.unit_guide;
                });
        },
        createProgressPoints() {
            // Implementación de la función aquí
            const progressPoints = document.getElementsByClassName('progress-point');
            for (let i = 0; i < this.points; i++) {
            progressPoints[i].classList.add('progress-test');
            }
        },
        progressBarWidth() {
            return (this.progressPercentage / this.points) * 100;
        },
        getConditionalClass(objetive) {
        const advancePercentage = objetive;
            return {
                green: advancePercentage >= 100,
                yellow: advancePercentage >= 50 && advancePercentage < 100,
                red: advancePercentage < 50,
            };
        },
    },
};
</script>
